import { render, staticRenderFns } from "./models.vue?vue&type=template&id=8bbf0216"
import script from "./models.vue?vue&type=script&lang=js"
export * from "./models.vue?vue&type=script&lang=js"
import style0 from "./models.vue?vue&type=style&index=0&id=8bbf0216&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports